module.exports = __webpack_public_path__ + "static/media/headerPicRight2.83245b14.svg";